import { fetchEndpoint } from "../network";

/**
 * 账号管理
 */

export default {
  // 列表
  list(params) {
    return fetchEndpoint("/create-platform/system/accounts", "GET", params);
  },
  lock(params) {
    return fetchEndpoint(
      "/create-platform/content/article/lock",
      "GET",
      params
    );
  },

  // 创建
  create(params) {
    return fetchEndpoint("/create-platform/system/account/add", "POST", params);
  },

  // 详情
  detail(params) {
    return fetchEndpoint(
      "/create-platform/system/account/detail",
      "GET",
      params
    );
  },

  // 修改
  modify(params) {
    return fetchEndpoint(
      "/create-platform/system/account/modify",
      "POST",
      params
    );
  },

  // 更新状态
  isStatus(params) {
    return fetchEndpoint(
      "/create-platform/system/account/modifyState",
      "GET",
      params
    );
  },

  // 删除
  remove(params) {
    return fetchEndpoint(
      "/create-platform/system/account/remove",
      "GET",
      params
    );
  },

  // 操作日志
  syslog(params) {
    return fetchEndpoint("/create-platform/system/syslog/list", "GET", params);
  },
  // 获取日志
  syslogList(params) {
    return fetchEndpoint("/system/syslog", "POST", params);
  },
  // 个人信息修改
  adminUpdate(data) {
    return fetchEndpoint("/admin/update", "POST", data);
  },
};
